// src/utils/download.ts
import { toast } from "vue-sonner";

export async function downloadFile(downloadUrl: string, filename: string) {
  try {
    const response = await fetch(downloadUrl);
    if (!response.ok) throw new Error("Failed to download file");
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(blobUrl);
    document.body.removeChild(a);
    toast.success("File downloaded");
  } catch (error) {
    toast.error("Error attempting to download file.");
    console.error(error);
  }
}

export function extractFilename(downloadUrl: string): string {
  const url = new URL(downloadUrl);
  const pathname = url.pathname;
  const parts = pathname.split("/");
  return parts[parts.length - 1] || "download";
}
